import type {RecruiterHubAction} from 'src/action-creators/recruiter-hub';
import type {RecruiterHubState} from 'src/types/recruiter-hub';

import {
  RECEIVE_RECRUITER_HUB_INFO,
  UPDATE_RECRUITER_HUB_INFO,
  RESET_RECRUITER_HUB_STATE,
} from 'src/action-creators/recruiter-hub';


const initialState: RecruiterHubState = {
  job_id: '',
  candidate_id: '',
  applicant_id: '',
  current_stage: '',
  current_owner_type: '',
  current_owner_id: '',
  screening_initiated_at: '',
  screening_source_type: '',
  screening_source_id: '',
  screening_summary: '',
  screening_transcript: '',
  screening_readable_transcript: '',
  screening_score: '',
};

export default (
  state: RecruiterHubState = initialState,
  action: RecruiterHubAction,
): RecruiterHubState => {
  switch (action.type) {
    case UPDATE_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_RECRUITER_HUB_STATE:
      return {...initialState};
  }
  return state;
};
